<div class="min-h-[80vh] flex items-center justify-center px-4 py-16 bg-station-cream">
  <div class="w-full max-w-md bg-white rounded-xl shadow-lg p-8">
    <h1 class="text-3xl font-bold mb-2 text-flap-black">Create your account</h1>
    <p class="text-rail-gray mb-8">Start building boards in under a minute.</p>

    @if (socialError(); as err) {
      <div
        class="mb-6 px-4 py-3 rounded-lg bg-signal-orange/10 border-2 border-signal-orange text-flap-black text-sm"
        role="alert"
      >
        {{ err }}
      </div>
    }

    <app-social-sign-in (failed)="socialError.set($event)" />

    <form (ngSubmit)="submit()" class="space-y-5">
      <div>
        <label for="name" class="block text-sm font-semibold text-flap-black mb-1">Name</label>
        <input
          id="name"
          type="text"
          autocomplete="name"
          required
          [ngModel]="name()"
          (ngModelChange)="name.set($event)"
          name="name"
          class="w-full px-4 py-3 rounded-lg border-2 border-border-subtle focus:border-signal-orange outline-none transition-colors"
        />
      </div>

      <div>
        <label for="email" class="block text-sm font-semibold text-flap-black mb-1">Email</label>
        <input
          id="email"
          type="email"
          autocomplete="email"
          required
          [ngModel]="email()"
          (ngModelChange)="email.set($event)"
          name="email"
          class="w-full px-4 py-3 rounded-lg border-2 border-border-subtle focus:border-signal-orange outline-none transition-colors"
        />
      </div>

      <div>
        <label for="password" class="block text-sm font-semibold text-flap-black mb-1"
          >Password</label
        >
        <input
          id="password"
          type="password"
          autocomplete="new-password"
          required
          minlength="8"
          [ngModel]="password()"
          (ngModelChange)="password.set($event)"
          name="password"
          class="w-full px-4 py-3 rounded-lg border-2 border-border-subtle focus:border-signal-orange outline-none transition-colors"
        />
        <p class="mt-1 text-xs text-rail-gray">At least 8 characters.</p>
      </div>

      @if (error(); as err) {
        <p class="text-sm text-signal-orange">{{ err }}</p>
      }

      <button
        type="submit"
        [disabled]="submitting()"
        class="w-full px-6 py-3 bg-signal-orange text-white rounded-lg font-semibold hover:bg-signal-orange/90 transition-colors disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer"
      >
        {{ submitting() ? 'Creating account…' : 'Sign up' }}
      </button>
    </form>

    <p class="mt-4 text-center text-xs text-rail-gray">
      By creating an account, you agree to our
      <a routerLink="/terms" class="text-signal-orange font-semibold hover:underline"
        >Terms of Service</a
      >
      and
      <a routerLink="/privacy" class="text-signal-orange font-semibold hover:underline"
        >Privacy Policy</a
      >.
    </p>

    <p class="mt-6 text-center text-sm text-rail-gray">
      Already have an account?
      <a routerLink="/login" class="text-signal-orange font-semibold hover:underline">Log in</a>
    </p>
  </div>
</div>
